import React from 'react'
import ErrorMessage from 'shared/components/ErrorMessage'
// Styles
import styles from '../../../../shared/components/Input/styles.module.scss'
function Textarea({ required = false, integer = false, number = false, label, error, wrapClassName = '', ...props }) {
  function onNumberChange(e) {
    const value = e.target.value
    const regex = integer ? /^[0-9]*$/ : /^[0-9]*[.]?[0-9]*$/
    if (value === '' || regex.test(value)) {
      props.onChange(e)
    }
  }
  return (
    <div className={`${wrapClassName}`}>
      {label && (
        <div className="text-sm mb-2 opacity-50">
          {label} {required && <span className="text-red-500">*</span>}
        </div>
      )}
      <textarea {...props} className={`${styles.input} rounded-[4px] p-[22px] w-full`} rows={5} onChange={!number ? props.onChange : onNumberChange} required={required} />
      {error && <ErrorMessage text={error} />}
    </div>
  )
}

export default Textarea
